import Countable from 'countable';

const handleWordCount = () => {
  const bodySelector = '.single-post, .single-portfolio';
  const readingTimeSelector = '.reading-time';
  const postContentID = 'post-content';

  const body = document.querySelector(bodySelector);
  const postContent = document.getElementById(postContentID);

  if (body !== null && postContent !== null) {
    Countable.count(postContent, ({ words }) => {
      const wpm = 200;

      const timeToRead = Math.round(words / wpm);

      const readingTimeEl = document.querySelector(readingTimeSelector);

      if (readingTimeEl !== null) {
        readingTimeEl.textContent = timeToRead;
      }
    });
  }
};

export default handleWordCount;
